import { captureException } from '@sentry/react'
import { Slack } from 'src/services'
import { DefaultService, EmailDigestRequest } from 'src/services/openApiV2'
import { User } from 'src/types/user'
import { LOOP_SUPPORT_EMAIL, LOOP_SUPPORT_MAIL_EMAIL } from './config/config'
import { getFrontendAlertChannel } from './functions/slackSupport'

const slackService = new Slack()

interface slackMessage {
  title: string
  message: string
  channel?: string
  test?: boolean
}

const sendSlackNotification = async (
  slackMessageObject: slackMessage = {
    title: '',
    message: '',
    channel: 'fe-logs',
    test: false
  }
): Promise<void> => {
  try {
    // Only send Slack notifications in production (unless explicitly testing)
    if (process.env.NODE_ENV === 'production' || slackMessageObject.test) {
      await slackService.postSlack({
        channel: slackMessageObject.channel || getFrontendAlertChannel(),
        ...slackMessageObject
      })
      return
    }
  } catch (error) {
    throw new Error('Failed to send Slack notification: ' + (error as Error).message)
  }
}

interface SendSupportEmailParams {
  currentUser: User
  templateName: string
  emailBody: Object
  fromEmail?: string
  toEmails?: string[]
  ccEmails?: string[]
  replyToEmail?: string
  replyToName?: string
}

const sendSupportEmail = async ({
  currentUser,
  templateName,
  emailBody,
  fromEmail = LOOP_SUPPORT_MAIL_EMAIL,
  toEmails = [LOOP_SUPPORT_EMAIL],
  ccEmails = [],
  replyToEmail,
  replyToName
}: SendSupportEmailParams) => {
  const requestBody: EmailDigestRequest = {
    template_name: templateName,
    from_email: fromEmail,
    to_emails: toEmails,
    cc_emails: ccEmails,
    reply_to_email: replyToEmail ?? currentUser?.email,
    reply_to_name: replyToName ?? currentUser?.name,
    params: {
      b_name_in: ''
    },
    extra_data: emailBody as any
  }

  try {
    await DefaultService.triggerEmailDigestNotificationEmailDigestPost({ requestBody })
  } catch (error) {
    console.error('Failed to send support email:', error)

    captureException({
      message: 'Failed to send support email',
      level: 'error',
      tags: {
        type: 'bug-report',
        org: currentUser?.org,
        email: currentUser?.email,
        name: currentUser?.name
      },
      extra: requestBody
    })
  }
}

export { sendSlackNotification, sendSupportEmail }
